import { useLocation, useParams } from 'react-router-dom';
import HeaderSection from '../../components/home/HeaderSection';
import FooterSection from '../../components/home/FooterSection';
import TeacherAchievementsSection from '../../components/teacher/TeacherAchievementsSection';
import TeacherCertificationsSection from '../../components/teacher/TeacherCertificationsSection';
import TeacherCoursesSection from '../../components/teacher/TeacherCoursesSection';
import TeacherFaqSection from '../../components/teacher/TeacherFaqSection';
import TeacherHeroSection from '../../components/teacher/TeacherHeroSection';
import { useCanonicalTeacherUrl } from '../../hooks/useCanonicalTeacherUrl';
import { useInstructorDetail } from '../../hooks/useInstructorDetail';
import { parseTeacherIdFromSlug } from '../../utils/courseSlug';

function TeacherPageSkeleton() {
  return (
    <div className="animate-pulse px-4 py-10 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl rounded-3xl bg-white p-8 shadow-[0_8px_40px_rgba(0,0,0,0.08)]">
        <div className="h-10 w-64 rounded bg-white/70" />
        <div className="mt-4 h-5 w-40 rounded bg-white/60" />
        <div className="mt-6 space-y-3">
          <div className="h-4 w-full rounded bg-white/50" />
          <div className="h-4 w-5/6 rounded bg-white/50" />
          <div className="h-4 w-4/6 rounded bg-white/50" />
        </div>
      </div>
    </div>
  );
}

export default function TeacherPage() {
  const { teacherId: teacherSlug } = useParams();
  const teacherId = parseTeacherIdFromSlug(teacherSlug);
  const location = useLocation();
  const subjectColorCode = location.state?.subjectColorCode || null;
  const { teacher, loading, error } = useInstructorDetail(teacherId, { subjectColorCode });
  useCanonicalTeacherUrl(teacher);

  const showCertifications =
    teacher?.certifications?.length > 0 || teacher?.certificationStory;

  return (
    <>
      <HeaderSection />

      <main>
        {loading ? (
          <TeacherPageSkeleton />
        ) : error ? (
          <div className="mx-auto max-w-2xl px-4 py-16 text-center sm:px-6">
            <p className="rounded-lg bg-red-50 px-4 py-3 text-sm text-red-700">{error}</p>
          </div>
        ) : teacher ? (
          <>
            <TeacherHeroSection teacher={teacher} />
            {showCertifications && (
              <TeacherCertificationsSection
                certifications={teacher.certifications}
                story={teacher.certificationStory}
              />
            )}
            {teacher.achievements.length > 0 && (
              <TeacherAchievementsSection achievements={teacher.achievements} />
            )}
            {teacher.courses.length > 0 && (
              <TeacherCoursesSection courses={teacher.courses} />
            )}
            <TeacherFaqSection />
          </>
        ) : null}
      </main>

      <FooterSection />
    </>
  );
}
